import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=56c69cec&scoped=true&"
import script from "./QuestionModal.vue?vue&type=script&lang=js&"
export * from "./QuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=56c69cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c69cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c69cec')) {
      api.createRecord('56c69cec', component.options)
    } else {
      api.reload('56c69cec', component.options)
    }
    module.hot.accept("./QuestionModal.vue?vue&type=template&id=56c69cec&scoped=true&", function () {
      api.rerender('56c69cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/space/components/QuestionModal.vue"
export default component.exports